module.exports = __webpack_public_path__ + "static/media/buyingcar.bba9f776.png";